<div class="modal-header">
  <div class="d-flex align-items-center gap-2">
    <h5 class="modal-title"><i class="fal fa-home"></i> Combine Rentals to Parent-Child</h5>
    <app-page-help articleId="xsMarHt8GB6MQoRps2Vvzz"></app-page-help>
  </div>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<div class="modal-body p-0">
  <div class="d-flex align-items-start gap-3 p-3" style="background: #fcfcfd">
    <img src="/assets/images/rental-group/parent-child.svg" alt="" width="100" />
    <div class="flex-1">
      <h6 i18n class="mb-1">Easily Organize Rentals into a Parent-Child Setup</h6>
      <div i18n class="text-sm text-muted">
        Turn multiple rentals into a Parent-Child setup, where the parent unit is the leading property, and child units
        are its sub-listings.
      </div>

      <div class="alert alert-secondary-warning2 text-warning2 mb-0 mt-1 p-2">
        <div i18n class="text-semi-bold">For example:</div>
        <div i18n>
          A luxury villa with separate guest houses can be a Parent-Child setup, where guests book individual guest
          houses while managing them under the main villa listing.
        </div>
      </div>
    </div>
  </div>

  <div class="p-3 border-top border-bottom">
    <app-rental-select
      [ctrl]="form.get('parent_id')"
      [multiple]="false"
      [rentals$]="availableParents$"
      label="Select Parent Rental"
      placeholder="Parent Rental"
      infoIcon="far fa-question-circle"
      matTooltip="Choose the main rental that will serve as the parent unit. The parent unit cannot be booked directly but will help manage its child units."
      i18n-matTooltip
    >
    </app-rental-select>

    <app-rental-select
      [ctrl]="form.get('children')"
      [multiple]="true"
      [rentals$]="availableChildren$"
      label="Select Child Rentals"
      placeholder="Child Rentals"
      infoIcon="far fa-question-circle"
      matTooltip="Select the rentals that will be child units under the parent rental. Each child unit remains bookable with its own pricing and availability."
      i18n-matTooltip
    >
    </app-rental-select>
  </div>
  <div class="p-3" style="background: #fcfcfd">
    <div i18n>Preview:</div>
    <ul class="list-unstyled d-flex flex-column mb-0 overflow-auto" style="row-gap: 1px; max-height: 200px">
      <li
        *ngIf="parentIdCtrl.value"
        class="d-flex align-items-center gap-2 position-relative bg-active text-truncate"
        #parentRow
        style="min-height: 30px; padding: 0 25px 0"
      >
        <app-rental-group-label
          label="Parent"
          labelClass="bg-info text-white"
          [height]="parentRow.offsetHeight"
          class="position-absolute fw-normal"
          [style.left.px]="-7"
        ></app-rental-group-label>
        <div class="text-truncate">
          {{ parentIdCtrl.value | rentalName | async }}
          <span i18n class="text-light text-sm">(Parent Rental)</span>
        </div>
      </li>
      <li
        *ngFor="let id of form.get('children').value"
        class="d-flex align-items-center gap-2 position-relative bg-default text-truncate"
        #childRow
        style="min-height: 30px; padding: 0 25px 0"
      >
        <app-rental-group-label
          label="Child"
          labelClass="bg-secondary-info text-info"
          [height]="childRow.offsetHeight"
          class="position-absolute fw-normal"
          [style.left.px]="-7"
        ></app-rental-group-label>
        <div class="text-truncate">{{ id | rentalName | async }}</div>
      </li>
    </ul>
  </div>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-light">
    <span class="far fa-times"></span>
    Cancel
  </button>
  <button (click)="onSave(form)" type="button" class="btn btn-secondary-info" [disabled]="loading$ | async">
    <span class="cs-icon cs-icon-save" *ngIf="!(loading$ | async)"></span>
    <span class="far fa-spinner fa-spin" *ngIf="loading$ | async"></span>
    Save
  </button>
</div>
